import React, { Component } from 'react';
import CarLocations from 'components/widgets/autocompletes/carLocations';
import RangePicker from 'components/widgets/rangeDateTimePicker';
import ErrorHandler from 'libraries/errorHandler';
import ErrorTooltip from 'components/snippets/errorTooltip';
import buildQueryString from 'helpers/buildQueryString';
import Lang from 'libraries/Lang';
import moment from 'moment';

class Car extends Component {
    constructor(props) {
        super(props);

        moment.locale(window.Locale);

        const stateValue = {
            pickupLocation: null,
            dropoffLocation: null,
            pickupCountry: null,
            dropoffCountry: null,
            pickupCity: null,
            dropoffCity: null,
            pickupCountryId: '',
            dropoffCountryId: '',
            pickupCityId: '',
            dropoffCityId: '',
            pickupDate: null,
            dropoffDate: null,
            pickupTime: { value: '10:00', text: '10:00 am' },
            dropoffTime: { value: '10:00', text: '10:00 am' },
            showDropoff: true,
            shouldValidate: false,
            Traveltoken: props.Traveltoken,
            TravelRedirect: props.TravelRedirect,
        };

        const rules = {
            'form.pickupCountry': (country) => {
                let valid = true;

                if (country === null || Object.keys(country).length === 0) {
                    valid = 'Select a pickup country';
                }

                return valid;
            },

            'form.pickupCity': (city) => {
                let valid = true;

                if (city === null || Object.keys(city).length === 0) {
                    valid = 'Select a pickup city';
                }

                return valid;
            },

            'form.pickupLocation': (location) => {
                let valid = true;

                if (location === null || Object.keys(location).length === 0) {
                    valid = 'Select a pickup location';
                }

                return valid;
            },

            'form.dropoffCountry': (country) => {
                let valid = true;

                if (country === null || Object.keys(country).length === 0) {
                    valid = 'Select a dropoff country';
                }

                return valid;
            },

            'form.dropoffCity': (city) => {
                let valid = true;

                if (city === null || Object.keys(city).length === 0) {
                    valid = 'Select a dropoff city';
                }

                return valid;
            },

            'form.dropoffLocation': (destination) => {
                let valid = true;

                if (destination === null || Object.keys(destination).length === 0) {
                    valid = 'Select a dropoff location';
                }

                return valid;
            },
            'form.dates': (date) => {
                let valid = true;
                if (date === null || Object.keys(date).length === 0) {
                    valid = 'Please selected a valid pickup and dropoff date';
                }
                return valid;
            },
        };
        this.errorHandler = new ErrorHandler(rules);

        const storage = localStorage.getItem('carEngine');
        try {
            if (storage !== null && storage.length > 0) {
                Object.assign(stateValue, JSON.parse(storage));

                if (stateValue.pickupDate !== null) {
                    stateValue.pickupDate = moment(stateValue.pickupDate);
                    if (stateValue.pickupDate.isBefore(moment())) {
                        stateValue.pickupDate = moment();
                    }
                }

                if (stateValue.dropoffDate !== null) {
                    stateValue.dropoffDate = moment(stateValue.dropoffDate);
                    if (stateValue.dropoffDate.isBefore(moment())) {
                        stateValue.dropoffDate = moment().add(1, 'day');
                    }
                }
            }
        } catch (e) {
            // console.log(e);
            localStorage.removeItem('carEngine');
        }

        this.state = stateValue;

        this.onSelectLocation = this.onSelectLocation.bind(this);
        this.onSelectCountry = this.onSelectCountry.bind(this);
        this.onSelectCity = this.onSelectCity.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onTimeChange = this.onTimeChange.bind(this);
        this.changeShowDropoff = this.changeShowDropoff.bind(this);
        this.submit = this.submit.bind(this);
    }

    onSelectCountry(country, type) {
        if (!country) return null;

        if (type === 'pickup') {
            this.setState({
                pickupCountry: country,
                pickupCountryId: country.value,
            });
        } else {
            this.setState({
                dropoffCountry: country,
                dropoffCountryId: country.value,
            });
        }

        const { shouldValidate } = this.state;
        let formLabel = 'form.pickupCountry';

        if (shouldValidate) {
            if (type === 'dropoff') formLabel = 'form.dropoffCountry';

            this.errorHandler.checkRule(formLabel, country);
        }
    }

    onSelectCity(city, type) {
        if (!city) return null;

        if (type === 'pickup') {
            this.setState({
                pickupCity: city,
                pickupCityId: city.value,
            });
        } else {
            this.setState({
                dropoffCity: city,
                dropoffCityId: city.value,
            });
        }

        const { shouldValidate } = this.state;
        let formLabel = 'form.pickupCity';

        if (shouldValidate) {
            if (type === 'dropoff') formLabel = 'form.dropoffCity';

            this.errorHandler.checkRule(formLabel, city);
        }
    }

    onSelectLocation(destination, type) {
        if (!destination) return null;

        if (type === 'pickup') {
            this.setState({ pickupLocation: destination });
        } else {
            this.setState({ dropoffLocation: destination });
        }

        const { shouldValidate } = this.state;
        let formLabel = 'form.pickupLocation';

        if (shouldValidate) {
            if (type === 'dropoff') formLabel = 'form.dropoffLocation';

            this.errorHandler.checkRule(formLabel, destination);
        }
    }

    onDateChange(pickupDate, dropoffDate) {
        let pickupDateTime = pickupDate;
        if (pickupDate) {
            const pickupDateValue = pickupDate.format('YYYY-MM-DDTHH:mm:ss');
            const dateTime = pickupDate.format('YYYY-MM-DD') + pickupDateValue.slice(10);
            pickupDateTime = moment(dateTime, 'YYYY-MM-DDTHH:mm:ss');
        }

        let dropoffDateTime = dropoffDate;
        if (dropoffDate) {
            const dropoffDateValue = dropoffDate.format('YYYY-MM-DDTHH:mm:ss');
            const dateTime = dropoffDate.format('YYYY-MM-DD') + dropoffDateValue.slice(10);
            dropoffDateTime = moment(dateTime, 'YYYY-MM-DDTHH:mm:ss');
        }

        this.setState({ pickupDate: pickupDateTime, dropoffDate: dropoffDateTime });

        const { shouldValidate } = this.state;
        if (shouldValidate) {
            this.errorHandler.checkRule('form.dates', pickupDate);
        }
    }

    onTimeChange(pickupTime, dropoffTime) {
        const { pickupDate, dropoffDate } = this.state;

        if (pickupTime !== null) {
            if (pickupDate) {
                const dateTime = `${pickupDate.format('YYYY-MM-DD')} ${moment(pickupTime.text, 'hh:mm A').format('HH:mm:ss')}`;
                const pickupDateTime = moment(dateTime, 'YYYY-MM-DDTHH:mm:ss');
                this.setState({ pickupDate: pickupDateTime, pickupTime });
            } else {
                this.setState({ pickupTime });
            }
        }

        if (dropoffTime !== null) {
            if (dropoffDate) {
                const datetime = `${dropoffDate.format('YYYY-MM-DD')} ${moment(dropoffTime.text, 'hh:mm A').format('HH:mm:ss')}`;
                const dropoffDateTime = moment(datetime, 'YYYY-MM-DDTHH:mm:ss');
                this.setState({ dropoffDate: dropoffDateTime, dropoffTime });
            } else {
                this.setState({ dropoffTime });
            }
        }
    }

    changeShowDropoff(e) {
        this.setState({
            showDropoff: e.target.checked,
        });
    }

    submit(event) {
        event.preventDefault();
        const {
            pickupLocation,
            dropoffLocation,
            pickupCountry,
            dropoffCountry,
            pickupCity,
            dropoffCity,
            pickupCountryId,
            dropoffCountryId,
            pickupCityId,
            dropoffCityId,
            pickupTime,
            dropoffTime,
            pickupDate,
            dropoffDate,
            showDropoff,
            Traveltoken,
            TravelRedirect,
        } = this.state;

        this.errorHandler.checkRule('form.pickupCountry', pickupCountry);
        this.errorHandler.checkRule('form.pickupCity', pickupCity);
        this.errorHandler.checkRule('form.pickupLocation', pickupLocation);
        this.errorHandler.checkRule('form.dates', pickupDate);

        if (showDropoff) {
            this.errorHandler.checkRule('form.dropoffCountry', dropoffCountry);
            this.errorHandler.checkRule('form.dropoffCity', dropoffCity);
            this.errorHandler.checkRule('form.dropoffLocation', dropoffLocation);
        } else {
            this.errorHandler.clear('form.dropoffCountry');
            this.errorHandler.clear('form.dropoffCity');
            this.errorHandler.clear('form.dropoffLocation');
        }

        const errors = this.errorHandler.getErrors();

        if (Object.keys(errors).length > 0) {
            this.setState({ shouldValidate: true });

            return false;
        }

        event.preventDefault();
        // const params = {};

        // params.pickupLocation = pickupLocation.text;
        // params.pickupLocation_hidden = pickupLocation.value;

        // params.dropoffLocation = (showDropoff ? dropoffLocation.value : pickupLocation.text);
        // params.dropoffLocation_hidden = (showDropoff ? dropoffLocation.code : pickupLocation.value);

        // params.pickupDate = pickupDate.format('MM/DD/YYYY');
        // params.dropoffDate = dropoffDate.format('MM/DD/YYYY');
        // params.pickupTime = pickupDate.format('HH:mm');
        // params.dropoffTime = dropoffDate.format('HH:mm');
        // params.transmission = '*';
        // params.lang = window.Locale;

        /* open interstitial */
        // const modalToFrom = document.getElementById('mdl_fromTo');
        // const modalTravelTime = document.getElementById('mdl_travelTime');

        // modalToFrom.innerHTML = `${params.pickupLocation}`;
        // modalTravelTime.innerHTML = `${pickupDate.format('LL')} ${Lang.trans('engine.to')} ${dropoffDate.format('LL')}`;

        // Modal.show('#mdl_interstitial');
        // const loader = new Loader({
        //     bar: document.getElementById('mdl_InterLoaderbar'),
        // });
        // loader.start();

        // const queryString = buildQueryString(params);

        // const url = TravelRedirect+"/?t=" + Traveltoken +"&"+queryString;
        // window.location.href = url;

        // window.location.href = `https://res.flights.ca/res/cars/search?${queryString}`;
        // window.location.href = `https://secure.redtag.ca/res/cars/search?${queryString}`;
        // window.location.href = `https://secure.his-traveljapan.com/cars/search?${queryString}`;

        const bundles = {};
        const params = {};

        params.pickupLocation = pickupLocation !== null ? pickupLocation : '',
        params.dropoffLocation = dropoffLocation !== null ? dropoffLocation : '',
        params.pickupCountry = pickupCountry !== null ? pickupCountry : '',
        params.dropoffCountry = dropoffCountry !== null ? dropoffCountry : '',
        params.pickupCity = pickupCity !== null ? pickupCity : '',
        params.dropoffCity = dropoffCity !== null ? dropoffCity : '',
        params.pickupCountryId = pickupCountryId !== '' ? pickupCountryId : '',
        params.dropoffCountryId = dropoffCountryId !== '' ? dropoffCountryId : '',
        params.pickupCityId = pickupCityId !== '' ? pickupCityId : '',
        params.dropoffCityId = dropoffCityId !== '' ? dropoffCityId : '',
        params.pickupTime = pickupDate.format('HH:mm'),
        params.dropoffTime = dropoffDate.format('HH:mm'),
        params.pickupDate = pickupDate.format('MM/DD/YYYY'),
        params.dropoffDate = dropoffDate.format('MM/DD/YYYY'),
        params.showDropoff = showDropoff,

        params.selectedProducts = 'C';

        console.log('params', params);

        bundles.bundles = [{ ...params }];

        // bundles.refundable = "1";
        bundles.lang = window.Locale;
        bundles.currency = 'USD';
        bundles.affiliate = 'redtag';

        const queryString = JSON.stringify(bundles);
        const encodeUrl = encodeURI(queryString);
        // console.log('queryString',queryString);
        // console.log('encodeUrl', encodeUrl);
        const url = `${TravelRedirect}/create?t=${Traveltoken}&request=${encodeUrl}`;
        window.location.href = url;

        const storage = {
            pickupLocation,
            dropoffLocation,
            pickupCountry,
            dropoffCountry,
            pickupCity,
            dropoffCity,
            pickupCountryId,
            dropoffCountryId,
            pickupCityId,
            dropoffCityId,
            pickupTime,
            dropoffTime,
            pickupDate,
            dropoffDate,
            showDropoff,
        };

        localStorage.setItem('carEngine', JSON.stringify(storage));
    }

    render() {
        const errorOutput = {};
        const {
            pickupLocation,
            dropoffLocation,
            pickupCountry,
            dropoffCountry,
            pickupCity,
            dropoffCity,
            pickupCountryId,
            dropoffCountryId,
            pickupCityId,
            dropoffCityId,
            pickupTime,
            dropoffTime,
            pickupDate,
            dropoffDate,
            showDropoff,
        } = this.state;

        const errors = this.errorHandler.getErrors();

        return (
            <form className="search-car" onSubmit={this.submit}>
                <input type="hidden" name="request" value="" />
                <div className="row gutter-10 mb-3">
                    <div className="col-auto">
                        <div className="styled-radio black-text">
                            <input type="radio" id="radio-net" name="trip" value="net" defaultChecked />
                            <label className="text-label" htmlFor="radio-net">
                                <span>Net</span>
                            </label>
                        </div>
                        <div className="styled-radio black-text">
                            <input type="radio" id="radio-gross" name="trip" value="gross" />
                            <label className="text-label" htmlFor="radio-gross">
                                <span>Gross</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="row gutter-10 mb-md-2">
                    <div className="col-12 col-md-12 col-lg-12 col-xl-9 city-country">
                        <div className="element-container">
                            <div className="row gutter-0">
                                <div className="col-md col-12">
                                    <div className="select-unstyled-container">
                                        <label className="text-label" htmlFor="cars_pickup_country">Pick up Country</label>
                                        <div className="element-wrapper">
                                            <CarLocations
                                                id="cars_pickup_country"
                                                countryId={pickupCountryId}
                                                cityId={pickupCityId}
                                                placeholder="Select a country"
                                                onSelect={(pickupCountry) => this.onSelectCountry(pickupCountry, 'pickup')}
                                                value={pickupCountry}
                                            />
                                            {errors.form && errors.form.pickupCountry && (
                                                <ErrorTooltip error={{ message: errors.form.pickupCountry, id: 'pickupCountry' }} />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md col-6">
                                    <div className="select-unstyled-container">
                                        <label className="text-label" htmlFor="cars_pickup_city">Pick up City</label>
                                        <div className="element-wrapper">
                                            <CarLocations
                                                id="cars_pickup_city"
                                                countryId={pickupCountryId}
                                                cityId={pickupCityId}
                                                placeholder="Select a city"
                                                onSelect={(pickupCity) => this.onSelectCity(pickupCity, 'pickup')}
                                                value={pickupCity}
                                            />
                                            {errors.form && errors.form.pickupCity && (
                                                <ErrorTooltip error={{ message: errors.form.pickupCity, id: 'pickupCity' }} />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md col-6">
                                    <div className="">
                                        <label className="text-label" htmlFor="cars_pickup_location">Pick up location</label>
                                        <div className="element-wrapper">
                                            <CarLocations
                                                id="cars_pickup_location"
                                                countryId={pickupCountryId}
                                                cityId={pickupCityId}
                                                placeholder="Select a location"
                                                onSelect={(pickupLocation) => this.onSelectLocation(pickupLocation, 'pickup')}
                                                value={pickupLocation}
                                            />
                                            {errors.form && errors.form.pickup && (
                                                <ErrorTooltip error={{ message: errors.form.pickup, id: 'pickup' }} />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            { showDropoff && (
                                <div className="row gutter-0">
                                    <div className="col-md col-12">
                                        <div className="select-unstyled-container">
                                            <label className="text-label" htmlFor="cars_dropoff_country">Pick up Country</label>
                                            <div className="element-wrapper">
                                                <CarLocations
                                                    id="cars_dropoff_country"
                                                    countryId={dropoffCountryId}
                                                    cityId={dropoffCityId}
                                                    placeholder="Select a country"
                                                    onSelect={(dropoffCountry) => this.onSelectCountry(dropoffCountry, 'dropoff')}
                                                    value={dropoffCountry}
                                                />
                                                {errors.form && errors.form.pickupCountry && (
                                                    <ErrorTooltip error={{ message: errors.form.pickupCountry, id: 'pickupCountry' }} />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md col-6">
                                        <div className="select-unstyled-container">
                                            <label className="text-label" htmlFor="cars_dropoff_city">Pick up City</label>
                                            <div className="element-wrapper">
                                                <CarLocations
                                                    id="cars_dropoff_city"
                                                    countryId={dropoffCountryId}
                                                    cityId={dropoffCityId}
                                                    placeholder="Select a city"
                                                    onSelect={(dropoffCity) => this.onSelectCity(dropoffCity, 'dropoff')}
                                                    value={dropoffCity}
                                                />
                                                {errors.form && errors.form.pickupCity && (
                                                    <ErrorTooltip error={{ message: errors.form.pickupCity, id: 'pickupCity' }} />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md col-6">
                                        <div className="">
                                            <label className="text-label" htmlFor="cars_dropoff_location">Pick up location</label>
                                            <div className="element-wrapper">
                                                <CarLocations
                                                    id="cars_dropoff_location"
                                                    countryId={dropoffCountryId}
                                                    cityId={dropoffCityId}
                                                    placeholder="Select a location"
                                                    onSelect={(dropoffLocation) => this.onSelectLocation(dropoffLocation, 'dropoff')}
                                                    value={dropoffLocation}
                                                />
                                                {errors.form && errors.form.pickup && (
                                                    <ErrorTooltip error={{ message: errors.form.pickup, id: 'pickup' }} />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) }
                        </div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-12 col-xl-3 col-xxl-3 duration">
                        <div className="element-container range-picker-container">
                            <RangePicker
                                startDateId="car_pickupDate"
                                endDateId="car_dropoffDate"
                                onDatesChange={(pickupDate, dropoffDate) => { this.onDateChange(pickupDate, dropoffDate); }}
                                minDate={2}
                                startDatePlaceholderText="Pickup Date"
                                endDatePlaceholderText="Dropoff Date"
                                startDate={pickupDate}
                                endDate={dropoffDate}
                            />
                            {errors.form && errors.form.dates && (
                                <ErrorTooltip error={{ message: errors.form.dates, id: 'dates' }} />
                            )}
                        </div>
                    </div>
                </div>
                <div className="row gutter-10 mb-3 mb-xl-5">
                    <div className="col-auto">
                        <div className="styled-checkbox font-weight-500">
                            <input type="checkbox" id="car_showDropOff" checked={showDropoff} onChange={this.changeShowDropoff} />
                            <label htmlFor="car_showDropOff">
                                <span>Drop off at a different location</span>
                            </label>
                        </div>
                    </div>
                    <div className="col-auto">
                        <div className="styled-checkbox font-weight-500 d-flex align-items-center">
                            <input type="checkbox" id="checkbox-age" defaultChecked />
                            <label htmlFor="checkbox-age">
                                <span>Driver age 25-69 </span>
                            </label>
                            <button type="button" id="age-input-tooltip" className="btn-unstyled modal-btn text-right d-flex">
                                <svg className="icon grey-light" aria-hidden="true">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-info-italic-circle" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row gutter-10 border-top mt-2">
                    <div className="col-12 text-center  mb-2 mb-lg-0 mt-3">
                        <button type="submit" className="btn btn-primary btn-lg px-5 font-weight-600">
                            <span className="">Search</span>
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}

export default Car;
